module.exports = __webpack_public_path__ + "static/media/image3.cbbc2477.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/image3.png
// module id = 400
// module chunks = 0